import { Grid } from "@mui/material";
import Mobile1 from "../../../../assets/socialmedia/website-graphics1-mobile.webp";
import Mobile2 from "../../../../assets/socialmedia/website-graphics2-mobile.webp";
import Web1 from "../../../../assets/socialmedia/website-graphics1-web.webp";
import Web2 from "../../../../assets/socialmedia/website-graphics2-web.webp";
import Web3 from "../../../../assets/socialmedia/website-graphics3-web.webp";
import Web4 from "../../../../assets/socialmedia/website-graphics4-web.webp";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function WebsiteGraphicsContent() {
  const { isXs } = useBreakpoints();

  return (
    <Grid
      container={isXs}
      justifyContent={"center"}
      sx={{ position: "relative" }}
    >
      <img
        src={isXs ? Mobile1 : Web1}
        alt=""
        width={isXs ? "100%" : 250}
        style={{
          objectFit: "cover",
          position: isXs ? "static" : "absolute",
          left: 40,
          top: 20,
          borderRadius: 24,
        }}
      />
      <img
        src={isXs ? Mobile2 : Web3}
        alt=""
        width={isXs ? "100%" : 349}
        height={isXs ? undefined : 296}
        style={{
          objectFit: "cover",
          position: isXs ? "static" : "absolute",
          left: 40,
          top: 300,
          marginTop: isXs ? 15 : 0,
          borderRadius: 24,
        }}
      />
      {!isXs && (
        <img
          src={Web2}
          alt=""
          width={isXs ? "100%" : 340}
          style={{
            objectFit: "cover",
            position: isXs ? "static" : "absolute",
            left: 310,
            top: 20,
            borderRadius: 24,
          }}
        />
      )}
      {!isXs && (
        <img
          src={Web4}
          alt=""
          width={isXs ? "100%" : 240}
          style={{
            objectFit: "cover",
            position: isXs ? "static" : "absolute",
            left: 410,
            top: 300,
            borderRadius: 24,
          }}
        />
      )}
    </Grid>
  );
}
